export function handleKeyPress(event, func) {
  let _enter = 13;
  let _space = 32;

  if (event.which === _space || event.which === _enter) {
    func();
  }
}
